/**
 * Workshop Booking — venue identity, discovery flags, and list sort.
 * Depends on WorkshopBookingGeo only. Sort policy is injected (OCP).
 */
(function (global) {
  if (global.WorkshopBookingVenueModel) return;

  var Geo = global.WorkshopBookingGeo || {};

  function normalizeVenueRefKey(ref) {
    var s = String(ref || '').trim();
    if (!s) return '';
    var m = s.match(/Metaobject\/(\d+)/i);
    if (m) return 'gid://shopify/Metaobject/' + m[1];
    if (/^\d+$/.test(s)) return 'gid://shopify/Metaobject/' + s;
    return s;
  }

  function firstCoord() {
    return Geo.firstCoord.apply(Geo, arguments);
  }

  function venueGroupKey(v) {
    var lat = firstCoord(v.lat, v.venue_lat);
    var lng = firstCoord(v.lng, v.venue_lng);
    if (lat != null && lng != null) return 'll:' + lat.toFixed(4) + ',' + lng.toFixed(4);
    var ref = normalizeVenueRefKey(v.venue_ref_id || v.id || '');
    if (ref) return 'ref:' + ref;
    var h = String(v.venue_handle || v.handle || '').trim().toLowerCase();
    if (h) return 'h:' + h;
    return 'name:' + String(v.venue_name || v.name || v.city_name || '').trim().toLowerCase();
  }

  function venueGroupLabel(v) {
    return (v.city_name || v.city || v.venue_city || v.venue_name || v.name || '').toString().trim();
  }

  function getDisplayCity(event) {
    var clean = function (s) { return (s == null ? '' : String(s)).trim(); };
    if (clean(event.city)) return clean(event.city);
    if (clean(event.venue_name)) return clean(event.venue_name);
    if (clean(event.venue_handle)) {
      return clean(event.venue_handle)
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, function (m) { return m.toUpperCase(); });
    }
    return 'Unknown';
  }

  function venueHasEventsFlag(v) {
    if (!v || typeof v !== 'object') return null;
    var hasEvRaw = v.has_events;
    if (hasEvRaw === true) return true;
    if (hasEvRaw === false) return false;
    return null;
  }

  function venueIsWaitlistFromApi(v) {
    if (!v || typeof v !== 'object') return true;
    if (v._wbWaitlistVenue === true) return true;
    return venueHasEventsFlag(v) === false;
  }

  function venueHasScheduledEvents(v) {
    if (!v || typeof v !== 'object') return false;
    if (v._wbWaitlistVenue === true) return false;
    return venueHasEventsFlag(v) === true;
  }

  function venueHasBookableEvents(v) {
    return venueHasScheduledEvents(v);
  }

  function groupHasScheduledEvents(g) {
    if (!g || !Array.isArray(g.venues)) return false;
    for (var gi = 0; gi < g.venues.length; gi++) {
      if (venueHasScheduledEvents(g.venues[gi])) return true;
    }
    return false;
  }

  function normalizeSearchCityToken(str) {
    var s = String(str == null ? '' : str).trim().toLowerCase();
    if (!s) return '';
    var comma = s.indexOf(',');
    if (comma >= 0) s = s.slice(0, comma).trim();
    return s;
  }

  function groupExactCityMatch(group, searchCityToken) {
    if (!group || !searchCityToken) return false;
    var candidates = [group.city_label, group.city_name, group.city];
    var venues = group.venues || [];
    for (var i = 0; i < venues.length; i++) {
      var v = venues[i];
      if (!v) continue;
      candidates.push(v.city_name, v.city, v.venue_name, v.name);
    }
    for (var c = 0; c < candidates.length; c++) {
      var token = normalizeSearchCityToken(candidates[c]);
      if (token && token === searchCityToken) return true;
    }
    return false;
  }

  function catalogRegisterRef(map, ref, img) {
    var s = String(ref || '').trim();
    if (!s) return;
    map[s] = img;
    var norm = normalizeVenueRefKey(s);
    if (norm && norm !== s) map[norm] = img;
    var num = s.match(/(\d+)$/);
    if (num && num[1]) map[num[1]] = img;
  }

  function markRefInSet(set, ref) {
    var s = String(ref || '').trim();
    if (!s || !set) return;
    set[s] = true;
    var norm = normalizeVenueRefKey(s);
    if (norm && norm !== s) set[norm] = true;
    var num = s.match(/(\d+)$/);
    if (num && num[1]) set[num[1]] = true;
  }

  function refInSet(set, ref) {
    var s = String(ref || '').trim();
    if (!s || !set) return false;
    if (set[s]) return true;
    var norm = normalizeVenueRefKey(s);
    if (norm && set[norm]) return true;
    var num = s.match(/(\d+)$/);
    return !!(num && num[1] && set[num[1]]);
  }

  /**
   * @param {{ sortMode?: string }} cfg
   * sortMode 'events_first' | 'distance' — injected so sort policy can change
   * without editing this module.
   */
  function create(cfg) {
    cfg = cfg || {};
    var sortMode = cfg.sortMode === 'events_first' ? 'events_first' : 'distance';
    var cmpDistance = Geo.cmpDistanceKmProp || function () { return 0; };

    function sortVenuesInGroup(venues) {
      if (!Array.isArray(venues)) return;
      venues.sort(function (a, b) {
        if (sortMode === 'events_first') {
          var ea = venueHasScheduledEvents(a) ? 1 : 0;
          var eb = venueHasScheduledEvents(b) ? 1 : 0;
          if (ea !== eb) return eb - ea;
        }
        return cmpDistance(a.distance_km, b.distance_km);
      });
    }

    function sortVenueGroups(groups) {
      if (!Array.isArray(groups)) return;
      var loc = (typeof window !== 'undefined' && window.__WORKSHOP_LOCATION__) || null;
      var searchCityToken = normalizeSearchCityToken(
        (loc && loc.city) || (loc && loc.label) || ''
      );
      groups.sort(function (a, b) {
        if (searchCityToken) {
          var ea = groupExactCityMatch(a, searchCityToken) ? 1 : 0;
          var eb = groupExactCityMatch(b, searchCityToken) ? 1 : 0;
          if (ea !== eb) return eb - ea;
        }
        if (sortMode === 'events_first') {
          var ha = groupHasScheduledEvents(a) ? 1 : 0;
          var hb = groupHasScheduledEvents(b) ? 1 : 0;
          if (ha !== hb) return hb - ha;
        }
        return cmpDistance(a.distance_km, b.distance_km);
      });
    }

    return {
      sortMode: sortMode,
      sortVenuesInGroup: sortVenuesInGroup,
      sortVenueGroups: sortVenueGroups
    };
  }

  global.WorkshopBookingVenueModel = {
    create: create,
    normalizeVenueRefKey: normalizeVenueRefKey,
    venueGroupKey: venueGroupKey,
    venueGroupLabel: venueGroupLabel,
    getDisplayCity: getDisplayCity,
    venueHasEventsFlag: venueHasEventsFlag,
    venueIsWaitlistFromApi: venueIsWaitlistFromApi,
    venueHasScheduledEvents: venueHasScheduledEvents,
    venueHasBookableEvents: venueHasBookableEvents,
    groupHasScheduledEvents: groupHasScheduledEvents,
    normalizeSearchCityToken: normalizeSearchCityToken,
    groupExactCityMatch: groupExactCityMatch,
    catalogRegisterRef: catalogRegisterRef,
    markRefInSet: markRefInSet,
    refInSet: refInSet
  };
})(typeof window !== 'undefined' ? window : this);
